export const addToFavoritesText = "kTLuP";
export default {addToFavoritesText};